import { Box, BoxProps, Chip, IconButton, MenuItem, Menu, Typography, Stack, Tooltip } from "../../components";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { ReactNode, useState } from "react";
import Check from "@mui/icons-material/Check";
import { useTheme } from "../../hooks";
import { useLocation } from "react-router-dom";

export type MenuItemType = {
  label: ReactNode;
  action: () => void;
  disabled?: boolean;
  active?: boolean;
  tooltip?: ReactNode;
};

export const DropDownMenu = (props: { menuItems?: MenuItemType[] }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const location = useLocation();
  const hasDialog = location.pathname.includes('dialog');

  const renderMenu = () => {
    return (
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {props.menuItems?.map((menuItem, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              menuItem.action();
              setAnchorEl(null);
            }}
            disabled={menuItem.disabled}
          >
            <Tooltip title={menuItem.tooltip} placement="right-end">
              <Stack direction="row" spacing="sm" alignItems={"center"}>
                <Typography color={menuItem.active ? theme.palette.success.main : "undefined"}>
                  {menuItem.label}
                </Typography>
                {menuItem.active && <Check color="success" />}
              </Stack>
            </Tooltip>
          </MenuItem>
        ))}
      </Menu>
    );
  };

  return (
    <Box display="inline-flex">
      <Box>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <ExpandCircleDownIcon sx={{ color: hasDialog ? "#ffffff" : "#08519c" }} />
        </IconButton>
      </Box>

      {renderMenu()}
    </Box>
  );
};
